module.exports = __webpack_public_path__ + "static/eventBg-2667763e60eb3c5b96390b096e4b96d5.jpg";